
import request from '../request';
import qs from 'qs';
// 预授权进度查询
const preLicensingQuery = (data) => {
    return request.post(`/api/wx/auth/preLicensing/query?${qs.stringify(data)}`, data)
}
// 预授权申请撤销
const cancelPreApp = (data) => {
    return request.post('/api/wx/auth/preLicensing/cancelPreApp', data)
}
// 预授权申请删除
const detelePreApp = (data) => {
    return request.post(`/api/wx/auth/preLicensing/detelePreApp?${qs.stringify(data)}`, data)
}
// 预授权申请授权解释
const getAuthExplain = (data) => {
    return request.post('/api/wx/auth/preLicensing/getAuthExplain', data)
}
// 预授权报案详情
const getPreAppDetilInfo = (data) => {
    return request.post('/api/wx/auth/preLicensing/getPreAppDetilInfo', data)
}
// 预授权案件详情
const getClaimsDetil = (data) => {
    return request.post('/api/wx/auth/preLicensing/getClaimsDetil', data)
}
// 获取预授权诊断内容
const getDiagnosis = (data) => {
    return request.post('/api/wx/auth/preLicensing/getDiagnosis', data)
}
// 获取授权申请的基本信息
const getPreAppBaseIfo = (data) => {
    return request.post('/api/wx/auth/preLicensing/getPreAppBaseIfo', data)
}
// 预授权服务指南下载
const getServiceTemplate = (data) => {
    return request.post(`/api/wx/auth/preLicensing/getServiceTemplate?${qs.stringify(data)}`, data)
}
// 预授权补件列表
const getAuthPatchFileList = (data) => {
    return request.post('/api/wx/auth/preLicensing/getAuthPatchFileList', data)
}
// 邮件发送预授权单证
const SendMail = (data) => {
    return request.post(`/api/wx/auth/preLicensing/SendMail?${qs.stringify(data)}`, data)
}
// 预授权单证下载
const getTemplate = (data) => {
    return request.post(`/api/wx/auth/preLicensing/getTemplate?${qs.stringify(data)}`, data)
}
// 预授权申请
const apply = function (data) {
    return request.post('/api/wx/auth/preLicensing/apply', data)
}
// 对象数组
export default {
    preLicensingQuery,
    cancelPreApp,
    detelePreApp,
    getAuthExplain,
    getPreAppDetilInfo,
    getClaimsDetil,
    getDiagnosis,
    getPreAppBaseIfo,
    getServiceTemplate,
    getAuthPatchFileList,
    SendMail,
    getTemplate,
    apply
};